module.exports = __webpack_public_path__ + "img/products_big_can_cherry.e8bd6e55.png";